import { Grid } from '@mui/material'
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import { Constants } from '../../../endPoints';
import axios from 'axios';


export default function Homecategory() {
    const [categories, setCategories] = useState([]);
    const [homepageCategoryIds, setHomepageCategoryIds] = useState([]);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const res = await axios.get(Constants.listCategory);
                const homepageCats = res.data.list.filter(cat => cat.is_homepage);
                setCategories(homepageCats);
                setHomepageCategoryIds(homepageCats.map(cat => cat.id));
            } catch (err) {
                console.error('Error fetching categories:', err);
            }
        };

        fetchCategories();
    }, []);
    const categoryIdsQuery = homepageCategoryIds.join(',');

    return (
        <>
            <section className='pt-5 pb-10'>
                <div className='container mx-auto px-4'>
                    <Grid container spacing={3}>
                        <Grid item lg={4}>
                            <h4 className='uppercase text-gray-600 text-xs tracking-[3px] lg:mt-10'>Find Your Favourites</h4>
                            <h2 className='headningfont lg:text-5xl text-3xl text-[#B3902D] capitalize mb-8 mt-6'>Add to your jewellery  wardrobe</h2>
                            <Link to={`/listing?category=${categoryIdsQuery}`} className="inline-block py-3 px-8 border-2 uppercase tracking-[2px]  text-xs border-black mb-5 hover:bg-black hover:text-white transition-all">All Categories</Link>
                        </Grid>
                        <Grid item lg={8} md={12}>
                            <Grid container spacing={2}>
                                {categories.map((category) => (
                                    <Grid key={category.id} item lg={4} md={6} xs={6}>
                                        <Link to={`/listing?category=${category.id}`} className="block text-center bg-[#f6f6f6] p-5 hover:scale-105 transition-all w-full">
                                            <img src={category.imageWithUrl} className='md:h-40 h-28 mx-auto' />
                                            <h3 className='uppercase text-black text-xs tracking-[3px] mt-3'>{category.name}</h3>
                                        </Link>
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
            </section>
        </>
    )
}
